import styled from 'styled-components'

import { DEVICE, BLOCK_MARGIN_TOP } from '../../../util/constants'
import { HeroP } from '../../styles/Utility.styles'
import { GriddedContentBlock } from '../../styles/Utility.styles'

export const GridContainer = styled(GriddedContentBlock)`
  margin-top: 0;
  padding-bottom: 0;
  @media ${DEVICE.tabletL} {
    padding-bottom: ${BLOCK_MARGIN_TOP}px;
  }
`

export const AdvanceLandingHero = styled.div`
  grid-column: 2 / 11;
  grid-row: 1;
`

export const TextColumn = styled.div`
  grid-row: 1;
  grid-column: 1;
`

export const HeroTextRegion = styled.div`
  display: flex;
  flex-direction: column;
  max-height: max-content;
  border-radius: 5px;
  margin-top: 60px;

  @media ${DEVICE.tabletL} {
    flex-direction: row;
    margin-top: 37px;
    min-height: calc(100% - 2rem * 1.2 - 37px);
  }
`

export const CenteredTextColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 14px 0 0 0;
  width: 100%;

  @media ${DEVICE.tabletL} {
    padding: 0;
  }
`

export const HeroTitle = styled.div`
  h1,
  h2 {
    font-size: 3.6rem;
    line-height: 1.35;
    font-weight: 300;
    color: var(--highlight-blue);
    /* padding: 25px 0; */

    @media ${DEVICE.tabletL} {
      font-size: 4.8rem;
      /* padding: 50px 0; */
    }

    @media ${DEVICE.laptopS} {
      /* Figma: H1 Desktop Light 64 */
      font-size: 6.4rem;
    }
  }
`

export const HeroText = styled(HeroP)`
  margin-top: 14px;
  padding-bottom: 24px;

  @media ${DEVICE.tabletG} {
    padding-right: 24px;
    margin-top: 16px;
  }

  @media ${DEVICE.desktop} {
    padding-bottom: unset;
  }
`
